import { Fragment } from 'react';
import { getAllProjects, MENU_PROJECTS_QUERY_KEY } from '../../data/planner-data-service';
import { NavLink } from 'react-router-dom';
import ProjectMenuItem from './project-menu-item';
import AddProject from './project-add';
import ProjectMenuDragTarget from './drag/project-menu-drag-target';
import { closeMobileMenu } from '../../../../menu/ui/mobile-menu-provider';
import { addDays, format } from 'date-fns';
import Stats from '../stats/stats';
import { useQuery } from '@tanstack/react-query';

const ProjectMenu = () => {

    const { data: response } = useQuery({
        queryKey: [MENU_PROJECTS_QUERY_KEY],
        queryFn: getAllProjects,
    });

    const tomorrow = addDays(new Date(), 1);

    return (
        <div className="side-menu flex flex-col xl:w-[250px] bg-slate-800 text-slate-100 leading-7 h-screen color-scheme-dark">
            <div className="overflow-auto p-3">

                <NavLink
                    onClick={ closeMobileMenu }
                    to={ `/planner/today` }
                    className="border-b border-slate-700 pb-2 mb-2 flex items-center">
                    <div
                        className="w-[10px] h-[10px] rounded-full mr-4"
                        style={{
                            backgroundColor: '#009688',
                        }}
                    />
                    <p>Today</p>
                </NavLink>

                <NavLink
                    onClick={ closeMobileMenu }
                    to={ `/planner/tags` }
                    className="border-b border-slate-700 pb-2 mb-2 flex items-center">
                    <div
                        className="w-[10px] h-[10px] rounded-full mr-4"
                        style={{
                            backgroundColor: '#4c6caf',
                        }}
                    />
                    <p>Tags</p>
                </NavLink>

                <NavLink
                    onClick={ closeMobileMenu }
                    to={ `/planner/summary` }
                    className="border-b border-slate-700 pb-2 mb-2 flex items-center">
                    <div
                        className="w-[10px] h-[10px] rounded-full mr-4"
                        style={{
                            backgroundColor: 'rgb(84, 209, 111)',
                        }}
                    />
                    <p>Summary</p>
                </NavLink>

                <div className="text-sm pb-3 pt-3 text-slate-400">Projects</div>

                {
                    response?.data?.map(project => {
                        return (
                            <Fragment key={ project.project_id }>
                                <ProjectMenuItem
                                    project={ project }
                                />

                                <ProjectMenuDragTarget
                                    targetProjectId={ project.project_id }
                                />
                            </Fragment>
                        )
                    })
                }

                <AddProject />

                <div className="text-sm pb-3 pt-3 text-slate-400">Actions</div>

                <NavLink
                    onClick={ closeMobileMenu }
                    to={ `/planner/day-${ format(tomorrow, `dd-MM-yyyy`) }` }
                    className="border-b border-slate-700 pb-2 mb-2 flex items-center">
                    <div
                        className="w-[10px] h-[10px] rounded-full mr-4"
                        style={{
                            backgroundColor: '#bd22a3',
                        }}
                    />
                    <p>Tomorrow</p>
                </NavLink>

                <NavLink
                    onClick={ closeMobileMenu }
                    to={ `/planner/search` }
                    className="pb-2 mb-2 flex items-center">
                    <div
                        className="w-[10px] h-[10px] rounded-full mr-4"
                        style={{
                            backgroundColor: '#fa9d27',
                        }}
                    />
                    <p>Search</p>
                </NavLink>

                <Stats stats={ response?.stats } />
            </div>
        </div>
    )
};

export default ProjectMenu;